<template>
  <v-row>
    <v-col cols="5" class="px-0 pr-1 d-flex">
      <v-card class="flex-grow-1">
        <v-card-title>{{ rulesValueText }}</v-card-title>
        <v-card-text>
          <v-row>
            <v-col class="py-0">
              <span>{{ rulesValueTooltip }}</span>
            </v-col>
          </v-row>
          <v-row align="center" justify="center">
            <v-col class="py-0">
              <v-text-field
                v-model.lazy="localRaffleValue"
                class="text-field mt-3"
                label="Valor"
                dense
                :error-messages="errorsRulesValue"
                outlined
                :type="raffle.rules.type === 'BY_SELECTED_ITEMS_QUANTITY' ? 'number' : 'text'"
                :prefix="raffle.rules.type !== 'BY_SELECTED_ITEMS_QUANTITY' ? 'R$' : ''"
                :disabled="isDisabled"
                @keydown="preventDefault($event, 'keydown')"
              />
            </v-col>
            <v-col v-if="raffle.rules.type === 'BY_COUPON_TOTAL_VALUE'" cols="3" class="py-0">
              <v-tooltip bottom max-width="300px">
                <template v-slot:activator="{ on }">
                  <span v-on="on">
                    <mf-toggle v-model="localRaffleCumulative" label="Acumulativo" />
                  </span>
                </template>
                <span
                  >Controla se o valor acumula entre compras. Quando ativado, duas compras de R$ 25,00 podem gerar um número da sorte em um sorteio com o valor
                  de R$ 50,00.</span
                >
              </v-tooltip>
            </v-col>
          </v-row>
          <v-row v-if="raffle.rules.type !== 'BY_COUPON_TOTAL_VALUE'">
            <v-col class="pt-0">
              <mf-info-card icon="info" :vHtml="cumulativeInfoContent" />
            </v-col>
          </v-row>
        </v-card-text>
      </v-card>
    </v-col>
    <v-col cols="7" class="px-0 pl-1 d-flex">
      <v-card class="flex-grow-1">
        <v-card-title>Limite de números da sorte</v-card-title>
        <v-card-text>
          <v-row>
            <v-col cols="6">
              <span>
                Limite de números da sorte por CPF/CNPJ
                <v-tooltip bottom max-width="300px">
                  <template v-slot:activator="{ on }">
                    <span v-on="on">
                      <mf-icon class="help-icon" size="18">info</mf-icon>
                    </span>
                  </template>
                  <span
                    >Número máximo que um CPF/CNPJ pode ter de números da sorte. Ao alcançar esse número, o usuário não receberá mais números da sorte.</span
                  >
                </v-tooltip>
              </span>
              <v-text-field
                v-model="raffle.max_numbers_per_person"
                class="text-field mt-3"
                label="Limite de números"
                placeholder="Sem limitação"
                outlined
                dense
                :error-messages="errorMaxNumbersPerPerson"
                :disabled="isDisabled"
                type="number"
                @keydown="preventDefault($event, 'keydown')"
              />
            </v-col>
            <v-col cols="6">
              <span>
                Limite de números da sorte por venda
                <v-tooltip bottom max-width="300px">
                  <template v-slot:activator="{ on }">
                    <span v-on="on">
                      <mf-icon class="help-icon" size="18">info</mf-icon>
                    </span>
                  </template>
                  <span>Número máximo que uma única venda pode gerar de números da sorte.</span>
                </v-tooltip>
              </span>
              <v-text-field
                v-model="raffle.max_numbers_per_coupon"
                class="text-field mt-3"
                label="Limite de números"
                placeholder="Sem limitação"
                outlined
                dense
                :error-messages="errorMaxNumbersPerCoupon"
                :disabled="isDisabled"
                type="number"
                @keydown="preventDefault($event, 'keydown')"
              />
            </v-col>
          </v-row>
        </v-card-text>
      </v-card>
    </v-col>
  </v-row>
</template>

<script>
import { mapState } from 'vuex'
import { preventNumberEvents } from '../../helpers'

export default {
  name: 'RaffleRulesConfiguration',
  props: {
    validations: {
      type: Object,
      default: () => {},
    },
    isDisabled: {
      type: Boolean,
      required: true,
      default: false,
    },
    errorMaxNumbersPerPerson: {
      type: String,
      required: true,
    },
    errorMaxNumbersPerCoupon: {
      type: String,
      required: true,
    },
    rulesValueTooltip: {
      type: String,
      required: true,
    },
    rulesValueText: {
      type: String,
      required: true,
    },
    errorsRulesValue: {
      type: String,
      required: true,
    },
    raffleValue: {
      type: [String, Number],
      required: true,
    },
    raffleCumulative: {
      type: Boolean,
      required: false,
    },
  },
  computed: {
    ...mapState({
      raffle: (state) => state.sorteio.raffle,
    }),
    localRaffleValue: {
      get() {
        return this.raffleValue
      },
      set(value) {
        this.$emit('update:raffle-value', value)
      },
    },
    localRaffleCumulative: {
      get() {
        return this.raffleCumulative
      },
      set(value) {
        this.$emit('update:raffle-cumulative', value)
      },
    },
    cumulativeInfoContent() {
      return '<span style="color: rgb(0, 77, 153)">Nesta modalidade de sorteio, o valor não é acumulativo entre compras, ou seja, os números da sorte são gerados <b>por cupom de venda</b> sem transferência de valor entre vendas.</span>'
    },
  },
  methods: {
    preventDefault(event, type) {
      return preventNumberEvents(event, type)
    },
  },
}
</script>
